import * as React from "react";
import Select from "react-select";

// This componeent courtesy of ChatGPT

type Props = {
  month?: number;
  year?: number;
  setMonth: (value?: number) => void;
  setYear: (value?: number) => void;
  containerClass?: string;
};

const months = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: new Date(2000, i).toLocaleString("en-US", { month: "long" }),
}));

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 76 }, (_, i) => ({
  value: currentYear - i,
  label: `${currentYear - i}`,
}));

/**
 * (Built by ChatGPT)
 * A reusable component for selecting a month and a year.
 * Displays two dropdowns side by side on larger screens and stacked on smaller screens.
 * @param {number} [month] - The currently selected month (1-12).
 * @param {number} [year] - The currently selected year.
 * @param {(value?: number) => void} setMonth - Callback function to update the selected month.
 * @param {(value?: number) => void} setYear - Callback function to update the selected year.
 * @param {string} [containerClass] - Additional CSS classes for styling the component.
 */
const MonthYearSelect = (props: Props) => {
  return (
    <div className={`${props.containerClass}`}>
      <div className="row g-2">
        <div className="col-12 col-md-6">
          <Select
            className="rounded"
            classNames={{
              control: () => "form-control p-1 rounded-2",
              dropdownIndicator: () => "py-0",
            }}
            options={months}
            isClearable={true}
            onChange={(selected) => props.setMonth(selected?.value)}
            value={months.find((m) => m.value === props.month) || null}
            placeholder="Select month…"
          />
        </div>
        <div className="col-12 col-md-6">
          <Select
            className="rounded"
            classNames={{
              control: () => "form-control p-1 rounded-2",
              dropdownIndicator: () => "py-0",
            }}
            options={years}
            isClearable={true}
            onChange={(selected) => props.setYear(selected?.value)}
            value={years.find((y) => y.value === props.year) || null}
            placeholder="Select year…"
          />
        </div>
      </div>
    </div>
  );
};

export default MonthYearSelect;
